import { createContext, useContext } from "react";
/**
 * Boolean canvas-surface flag: `true` when the flow is rendered in editor
 * mode, `false` when it's a read-only visualization. Consumed by node/edge
 * renderers to gate editor-only affordances (hover hit zones, etc.).
 */ export const EditorModeContext = createContext(false);
export function useEditorMode() {
    return useContext(EditorModeContext);
}

//# sourceMappingURL=EditorModeContext.js.map